













import { Vue, Component, Prop } from 'vue-property-decorator';

import closeIcon from '@/assets/icons/close.svg';
import closeHoverIcon from '@/assets/icons/close_hover.svg';

@Component({
  name: 'PopupHeader',
})
/**
 * @vuese
 * @group Atomic/Organisms
 * PopupHeader component
 */
export default class PopupHeader extends Vue {
  // [data]
  closeIcon: string = closeIcon;
  closeHoverIcon: string = closeHoverIcon;
  icon: string = closeIcon;

  // [method]
  hidePopup() {
    this.$emit('hide');
  }
}
